<script setup>
import { defineProps, defineEmits, onMounted, watch } from "vue";

import UmisisDataTable from "./UmisisDataTable.vue";
import { Pagination } from "../../ui/pagination/index.js";
import { storeToRefs } from "pinia"; // Placeholder

// 1. Define ALL props for the component, including selection props
const props = defineProps({
  fields: {
    type: Array,
    default: () => [],
  },
  useStore: {
    type: Object,
    required: true,
  },
  loadingRowCount: {
    type: Number,
    default: 10,
  },
  rowClass: {
    type: Function,
    default: () => "",
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
  selectedRows: {
    type: Array,
    default: () => [],
  },
  rowKey: {
    type: String,
    default: "id",
  },
});

const emit = defineEmits(["filters-changed", "update:selectedRows"]);

const { page, perPage, total, isLoading, orderDirection, orderBy, getItems } =
  storeToRefs(props.useStore);

watch(
  [
    () => props.useStore.page,
    () => props.useStore.perPage,
    () => props.useStore.orderBy,
    () => props.useStore.orderDirection,
  ],
  async ([page, perPage, orderBy, orderDirection]) => {
    // This runs automatically whenever any of these 4 change
    await props.useStore.fetchItems(); // Replace 'fetchData' with your actual action name
  },
);

const handleSort = (params) => {
  // Call the store action directly
  props.useStore.sortChanged(params);
};

onMounted(() => {
  props.useStore.fetchItems();
});
</script>

<template>
  <UmisisDataTable
    :loading="isLoading"
    :loading-row-count="loadingRowCount"
    :order-direction="orderDirection"
    :order-by="orderBy"
    :fields="fields"
    :rows="getItems"
    :row-class="rowClass"
    :selectable="selectable"
    :filters="filters"
    :selected-rows="selectedRows"
    :row-key="rowKey"
    @sort-changed="handleSort"
    @filters-changed="emit('filters-changed', $event)"
    @update:selected-rows="emit('update:selectedRows', $event)"
  >
    <!-- Slot for overriding specific cells, for using with the Actions column, for example -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </UmisisDataTable>
  <Pagination
    v-model:page="perPage"
    v-model:items-per-page="page"
    :total="total"
  />
</template>
